module.exports = __webpack_public_path__ + "static/media/izharahmad.82637e41.jpeg";